import { Box, Grid, Paper, Typography } from '@mui/material';
import TroubleLoggingInModal from 'src/components/TroubleLoggingInModal';

export default function LoginInfoCard() {
  return (
    <Grid item sx={{ my: '2rem', gap: '1rem' }}>
      <Paper
        sx={{ display: 'flex', flexDirection: 'column', p: '1rem', gap: '0.75rem' }}
        className="loginLinks"
      >
        <Box display="flex" justifyContent="center">
          <Typography component="span" sx={{ pr: '0.75rem' }}>
            Trouble logging in?{' '}
          </Typography>
          <TroubleLoggingInModal btnTxt="Click here" />
        </Box>
        <Box display="flex" justifyContent="center">
          <Typography component="span" sx={{ pr: '0.75rem' }}>
            County Homepage
          </Typography>
          <a href="https://www.utahcounty.gov/" data-cy="utahCountyHomePage">
            Click here
          </a>
        </Box>
      </Paper>
    </Grid>
  );
}
